class HaciendolaMegaMenu extends HTMLElement {
  constructor() {
    super()
    const menuItems = [
      ...document.querySelectorAll('.header .header__inline-menu li'),
    ]
    this.label = this.dataset.trigger.trim()
    this.linkTitle = this.label.toLowerCase()
    this.summary = undefined

    this.trigger = menuItems.find(item => {
      const summary = item.querySelector('summary')
      const search = (summary || item).textContent.toLowerCase().trim()

      if (summary) this.summary = summary
      if (summary && summary.nextElementSibling)
        summary.nextElementSibling.remove()
      return search === this.linkTitle
    })
    this.enableCaret = this.dataset.enableCaret === 'true' ? true : false 
    this.parent = this.trigger.closest('.header')

    if (this.trigger) {
      const lnk =
        this.trigger.querySelector('a') || this.trigger.querySelector('summary')
      lnk.style.display = 'flex'
      lnk.style.gap = '.3em'
      lnk.style.alignItems = 'center'
      lnk.innerHTML = `<span ${
        this.enableCaret ? 'class="h-megamenu-trigger-caret"' : ''
      }>${this.label}</span>`

      this.parent.appendChild(this)
      if (this.classList.contains('h-megamenu--fullwidth')) {
        this.style.width = `${window.innerWidth}px`
      }

      this.trigger.addEventListener('click', e => {
        e.preventDefault()
      })

      // this.trigger.addEventListener('click', e => this.hide(e))
      this.trigger.addEventListener('mouseenter', () => this.show())

      this.addEventListener('mouseenter', () => this.show())
      this.addEventListener('mouseleave', e => this.hide(e), false)
    }

    this.headerHover()
  }

  show() {
    const openedMM = this.parent.openedMM
    if (openedMM && openedMM !== this) openedMM.hide()
    this.parent.openedMM = this

    const top = this.trigger.offsetTop + this.trigger.offsetHeight
    this.style.setProperty('--top-position', `${top}px`)
    this.style.display = 'grid'
    this.trigger.classList.add('h-megamenu--trigger')
  }
  hide(e) {
    if (!e || e.target === this || e.target === this.trigger) {
      this.style.display = 'none'
      this.trigger.classList.remove('h-megamenu--trigger')
    }
  }
  headerHover() {
    const summary = this.parent.querySelectorAll('summary')
    summary.forEach(s => {
      if (!s !== this.summary) return
      s.addEventListener('mouseover', () => {
        this.hide()
      })
    })
  }
}

customElements.define('h-megamenu', HaciendolaMegaMenu)
